import { Flex, Tabs } from '@percent/lemonade'
import { StagesTabsProps } from './StagesTabs.types'
import styles from './StagesTabs.module.scss'

export function StagesTabs({ activeTab, setActiveTab, tabs }: Readonly<StagesTabsProps>) {
  return (
    <Flex className={styles.stagesTabs}>
      <Tabs scrollable firstTabSticky items={tabs} activeTab={activeTab} onChangeTab={newTab => setActiveTab(newTab)} />
    </Flex>
  )
}
